


import {
  computed,
  defineComponent,
  PropType,
  reactive,
} from '@vue/composition-api';
import type {
  HokkaidoAirportReportCar,
} from '@/models/externalReports/hokkaidoAirport/spHokkaidoAirportReport';
import type {
  HokkaidoAirportLabelSp,
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';
import hokkaidoAirportReportApi from '@/apis/externalReports/hokkaidoAirport/hokkaido_airport_report';
import useSpeech from '@/composables/useSpeech';
import { useRequestGuard } from '@/composables/useRequestGuard';
import { roundToIntervalMinutes } from '@/lib/dateTimeHelper';
import { REPORT_TS_ROUND_MINUTES } from '@/consts/externalReports/hokkaidoAirport';
import type { StandbyState } from '@/components/Sp/ExternalReports/HokkaidoAirport/types';

export default defineComponent({
  props: {
    hokkaidoAirportCar: {
      type: Object as PropType<HokkaidoAirportReportCar>,
      required: true,
    },
    userSettings: {
      type: Object as PropType<HokkaidoAirportSettings>,
      required: true,
    },
  },
  emits: ['startWorking', 'editContentAndRoad', 'showErrorOnCommon'],
  setup(props, { emit }) {
    const state = reactive<StandbyState>({
      showConfirmStartWorkingModal: false,
      hokkaidoAirportReport: props.hokkaidoAirportCar.report,
    });
    const { doSpeech } = useSpeech();
    const { doRequest, isRequesting } = useRequestGuard((errorMessage) => {
      emit('showErrorOnCommon', errorMessage);
    });

    const spLabels = computed<HokkaidoAirportLabelSp>(() => {
      return props.userSettings.sp;
    });

    // doRequest は失敗時に例外を投げ直すため、保存に失敗した場合は emit まで進まない
    const startWorking = async(): Promise<void> => {
      state.showConfirmStartWorkingModal = false;
      const operationStartTime = roundToIntervalMinutes(new Date(), REPORT_TS_ROUND_MINUTES);
      await doRequest(async() => {
        state.hokkaidoAirportReport = await hokkaidoAirportReportApi.updateHokkaidoAirportReportStart(
          state.hokkaidoAirportReport.id,
          { operation_start_ts: operationStartTime },
        );
      }, '作業開始に失敗しました。再度操作を行ってください。');
      doSpeech(spLabels.value.message.confirm_start_work);
      emit('startWorking', props.userSettings.choices.status.working.key, state.hokkaidoAirportReport);
    };
    const editContentAndRoad = (): void => {
      emit('editContentAndRoad');
    };

    return {
      state,
      isRequesting,
      spLabels,
      startWorking,
      editContentAndRoad,
    };
  },
});
